import React from "react";
import classes from "./Button.module.scss";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  outline?: boolean;
}

const Button: React.FC<Props> = ({
  outline,
  type = "button",
  children,
  ...rest
}) => {
  return (
    <button
      className={`${classes.btn} ${outline ? classes.outline : classes.button}`}
      type={type}
      {...rest} // ✅ Spread remaining props (disabled, onClick, etc.)
    >
      {children}
    </button>
  );
};

export default Button;
